import React from "react";
import * as styles from "./lyst-news-video-embed.css";

const HTML_TO_REACT_ATTR: Record<string, string> = {
    frameborder: "frameBorder",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    referrerpolicy: "referrerPolicy",
    class: "className",
    tabindex: "tabIndex",
};

const BOOLEAN_IFRAME_ATTRS = new Set(["allowfullscreen", "allowtransparency"]);

function parseIframeProps(html: string): React.IframeHTMLAttributes<HTMLIFrameElement> {
    const iframeMatch = html.match(/<iframe([^>]*)>/i);
    if (!iframeMatch) return {};

    const props: Record<string, unknown> = {};
    const attrRegex = /([\w-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|(\S+)))?/g;
    let match: RegExpExecArray | null;

    while ((match = attrRegex.exec(iframeMatch[1])) !== null) {
        const name = match[1].toLowerCase();
        if (name === "width" || name === "height") continue;
        const value = match[2] ?? match[3] ?? match[4];
        const propName = HTML_TO_REACT_ATTR[name] ?? name;
        props[propName] = BOOLEAN_IFRAME_ATTRS.has(name) ? true : value ?? "";
    }

    return props as React.IframeHTMLAttributes<HTMLIFrameElement>;
}

export function LystNewsVideoEmbed({ html }: { html: string }): React.ReactElement {
    const { title, ...iframeProps } = parseIframeProps(html);
    return (
        <div className={styles.videoEmbed}>
            <iframe title={title} className={styles.videoEmbed} {...iframeProps} />
        </div>
    );
}
